import type {DataNode} from 'antd/es/tree';

export const getDisplayText = (item: any): string =>
  item.text || item.name || item.description || `Node ${item.id}`;

export const getNodeKey = (item: any): string => {
  const groupId = item.idVariableGroup || '';
  const varId = item.idVariable || '';
  if (groupId && varId) return `${groupId}-${varId}`;
  if (groupId) return `group-${groupId}`;
  if (varId) return `var-${varId}`;
  return `unknown-${Math.random()}`;
};

export const convertToTreeData = (data: any[]): DataNode[] => {
  if (!data) return [];
  return data.map((item: any) => ({
    title: getDisplayText(item),
    key: getNodeKey(item),
    children: item.children ? convertToTreeData(item.children) : undefined,
    data: item,
  }));
};

export const getValueRowKey = (record: any): string => {
  const candidate = record?.idValue ?? record?.idImpactValue ?? record?.id;
  return candidate != null ? String(candidate) : '';
};

export const resolveScaleBandOptionId = (record: any, options: any[]): any => {
  if (!record || !Array.isArray(options) || options.length === 0) {
    return record?.scaleBand;
  }
  const candidates = [
    record.scaleBandId,
    record.scaleBand,
    record.scaleBandLabel,
  ].filter((v) => v != null);
  for (const candidate of candidates) {
    const byId = options.find((o) => String(o.id) === String(candidate));
    if (byId) return byId.id;
    const byLabel = options.find((o) => o.label === candidate);
    if (byLabel) return byLabel.id;
  }
  return record.scaleBand;
};

export const buildValuesQueryParams = (
  isParent: boolean,
  variableGroupId: string | number | null,
  variableId: string | number | null,
): Record<string, any> | undefined => {
  if (isParent && variableGroupId) return {idVariableGroup: variableGroupId};
  if (!isParent && variableId) return {idVariable: variableId};
  return undefined;
};

const ACCENT_PALETTE = ['#9747ff', '#258bf6', '#f99e33', '#65c376', '#5a86fb', '#d0371d'];

export const accentForId = (id: number | string | null | undefined): string => {
  if (id == null) return ACCENT_PALETTE[0];
  const n = typeof id === 'number'
    ? id
    : Array.from(String(id)).reduce((a, c) => a + c.charCodeAt(0), 0);
  return ACCENT_PALETTE[Math.abs(n) % ACCENT_PALETTE.length];
};

export const monoFromName = (name: string): string => {
  const cleaned = (name || '').trim();
  if (!cleaned) return '··';
  const parts = cleaned.split(/\s+/);
  if (parts.length === 1) return cleaned.slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
};

export const findParentGroup = (groups: any[], variableId: string | number | null): any | null => {
  if (variableId == null || !Array.isArray(groups)) return null;
  for (const g of groups) {
    const kids = g.children || [];
    if (kids.some((v: any) => String(v.idVariable) === String(variableId))) return g;
  }
  return null;
};
